import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=22718984"
import script from "./subjects.vue?vue&type=script&lang=js"
export * from "./subjects.vue?vue&type=script&lang=js"
import style0 from "./subjects.vue?vue&type=style&index=0&id=22718984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports